document.addEventListener('page:loaded', function(product) { 
    document.addEventListener('cart:quantity-changed', function(event) { 
        // Refresh button status when quantity changes 
        theme.cart.getCartData().then(refreshButtonStatus).catch((error) => { 
            console.error("Error getting cart data:", error); 
        }); 
    }); 
      window.addEventListener('focus', function() {
    theme.cart.getCartData().then(refreshButtonStatus).catch((error) => { 
      console.error("Error getting cart data:", error); 
    });
        });
    var addToCartButton = document.querySelector('[data-add-to-cart-sample]'); 
    var variantIdInput = document.querySelector('#variant-id'); 
    
    function refreshButtonStatus(cart) { 
        var uniqueSamples = new Set(); 
        var productInCart = false; 
        var productTitle = ""; 
        
        for (let item of cart.items) { 
    if (item.handle.endsWith('-s') || item.handle.endsWith('s-1')) { 
                uniqueSamples.add(item.variant_id); 
                if (item.variant_id == variantIdInput.value) { 
                    productInCart = true; 
                    productTitle = item.title; 
                } 
            } 
        } 
        
        var maxMessageDiv = document.querySelector('.max-message'); 
        var maxMessageP = document.querySelector('#max-message'); 
        
        if (uniqueSamples.size >= sampleMax && !productInCart) { 
            maxMessageP.style.display = 'block'; 
            maxMessageDiv.style.display = 'block'; 
            addToCartButton.setAttribute('disabled', ''); 
            addToCartButton.textContent = 'MAX SAMPLES REACHED'; 
        } else if (productInCart) { 
            maxMessageP.textContent = '1 ' + productTitle + ' already in the cart!'; 
            maxMessageDiv.style.display = 'block'; 
            addToCartButton.setAttribute('disabled', ''); 
            addToCartButton.textContent = 'SAMPLE ALREADY IN CART'; 
        } else { 
            maxMessageDiv.style.display = 'none'; 
            addToCartButton.removeAttribute('disabled'); 
            addToCartButton.textContent = 'GET A SAMPLE'; 
        } 
    } 
    
    // Refresh button status immediately upon page load 
    theme.cart.getCartData().then(cartData => { 
        refreshButtonStatus(cartData); 
        // Save cart data to localStorage 
        localStorage.setItem('cartData', JSON.stringify(cartData)); 
    }).catch((error) => { 
        console.error("Error getting cart data:", error); 
    }); 
    
    addToCartButton.addEventListener('click', function(event) { 
        event.preventDefault(); 
        var quantity = document.querySelector('#quantity').value; 
        var variantId = variantIdInput.value; 
        
        // Fetch cart data and refresh button status before adding to cart 
        theme.cart.getCartData().then(cartData => { 
            refreshButtonStatus(cartData); 
            var addButtonIsDisabled = addToCartButton.getAttribute('disabled'); 
            if (addButtonIsDisabled) { 
                return; // Do not add to cart if button is disabled 
            } 
            
            fetch('/cart/add.js', { 
                method: 'POST', 
                headers: { 
                    'Content-Type': 'application/json', 
                    'Accept': 'application/json' 
                }, 
                body: JSON.stringify({ quantity: quantity, id: variantId }) 
            }) 
            .then(response => response.json()) 
            .then(data => { 
                var addToCartEvent = new CustomEvent('ajaxProduct:added', { detail: { product: data } }); 
                document.dispatchEvent(addToCartEvent); 
                theme.cart.getCartData().then(cartData => { 
                    refreshButtonStatus(cartData); 
                    // Save cart data to localStorage 
                    localStorage.setItem('cartData', JSON.stringify(cartData)); 
                }).catch((error) => { 
                    console.error("Error getting cart data:", error); 
                }); 
            }) 
            .catch((error) => { 
                var addToCartErrorEvent = new CustomEvent('ajaxProduct:error', { detail: { errorMessage: error.message } }); 
                document.dispatchEvent(addToCartErrorEvent); 
            }); 
        }).catch((error) => { 
            console.error("Error getting cart data:", error); 
        }); 
    }); 
    
    // Refresh button status from saved cart data in localStorage upon page load 
    let savedCartData = localStorage.getItem('cartData'); 
    if (savedCartData) { 
        refreshButtonStatus(JSON.parse(savedCartData)); 
    } 
});
